<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="entityName">
        </base-page-header>

        <v-form v-model="form.valide">
            <v-row class="bg-white p-3">
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :items="actorsSenders.length > 0? actorsSenders.map(el => ({text: el.description,value: el})) : []"
                        v-model="selectActorsSenders"
                        :rules="formInputs.default.rules"
                        filled
                        clearable
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.intervenient-type-req')"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                    :items="actorsSenderTypes.length > 0? actorsSenderTypes.map(el => ({text: el.description,value: el})) : []"
                    v-model="selectActorsSendersType"
                    clearable
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    :label="$t('environmental-management.scheduling.profile-type-req')"
                    ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.producer')}}</h3>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-text-field
                    filled
                    v-model="form.producerEstablishment.nif"
                    @blur="getProducersEstablishmentNif()"
                    hide-details="auto"
                    :rules="formInputs.nif.rules"
                    :label="$t('environmental-management.scheduling.producer-nif')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-select
                    v-model="form.producerType"
                    :items="producerType.length > 0? producerType.map(el => ({text: el.description,value: +el.producerTypeId})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.scheduling.type-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="5">
                    <v-select
                    v-model="selectProducerEstablishment"
                    :items="producersEstablishment.length > 0? producersEstablishment.map(el => ({text: el.name,value: el})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.scheduling.establishment-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small v-if="producersEstablishment.length > 0" @click="obterProducer"> {{$t('environmental-management.scheduling.get-establishments')}} </v-btn>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.address"
                    filled
                    :rules="formInputs.default.rules"
                    hide-details="auto"
                    readonly
                    :label="$t('environmental-management.scheduling.address-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.postalCode"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.scheduling.postal-code-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.locality"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.scheduling.locale-req')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.residue-operator')}}</h3>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-combobox
                        clearable
                        filled
                        v-model="form.recipientEstablishment.nif"
                        :items="[userAuth.nif.substr(2)]"
                        :rules="formInputs.nif.rules"
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.nif-ogr-req')"
                        @change="getRecipientEstablishmentNif()"
                    ></v-combobox>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-select
                        v-if="recipientsEstablishment.length > 0"
                        v-model="selectRecipientEstablishment"
                        :items="recipientsEstablishment.length > 0? recipientsEstablishment.map(el => ({text: el.name,value: el})) : []"
                        :rules="formInputs.default.rules"
                        filled
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.establishments')"
                        :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small v-if="recipientsEstablishment.length > 0" @click="obterRecipient"> {{$t('environmental-management.scheduling.get-establishments')}} </v-btn>
                </v-col>


                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.residue')}}</h3>
                </v-col>
                <v-col cols="12" v-for="(residuo, index) in form.residuos" :key="index">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-autocomplete
                            :items="lerCodes.length > 0? lerCodes.map(el => ({text: el.description, value: el.lerCodeId})) : []"
                            :rules="formInputs.default.rules"
                            filled
                            @change="getOperationCodes(residuo.lerCodeId, index, residuo)"
                            v-model="residuo.lerCodeId"
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.residue-designation')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                            v-model="residuo.codigoLer"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.ler-code-req')"
                            readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                            :items="operationCodes.length > 0? operationCodes.map(el => ({text: el.operationCode,value: +el.operationCodeID})) : []"
                            v-model="residuo.operationCodeId"
                            @change="changeOperationCode(index)"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.code-operator-req')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field
                            v-model="residuo.quantity"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.qty')"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                                :items="containerTypesItems"
                                v-model="residuo.containerTypeID"
                                :rules="formInputs.default.rules"
                                filled
                                hide-details="auto"
                                :label="$t('backoffice.environmental.containers.title')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field
                                v-model="residuo.containerQuantity"
                                :rules="formInputs.default.rules"
                                filled
                                hide-details="auto"
                                :label="$t('backoffice.environmental.containers.qty')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>


                <v-col cols="12" class="mx-auto text-center">
                    <v-btn class="btn-primary-custom btn-red mr-md-3 mr-0 mb-3 mb-md-0" text @click="cancelEgar()">
                        {{$t('cancel')}}
                    </v-btn>
                    <v-btn rounded class="btn-primary-custom btn-grey mr-md-3 mr-0 mb-3 mb-md-0" @click="saveEgar(1)" :disabled="!form.valide">{{$t('save')}}</v-btn>
                    <v-btn rounded class="btn-primary-custom btn-grey mr-md-3 mr-0 mb-3 mb-md-0" @click="printEgarForm"
                           :disabled="!form.valide">{{ $t('print') }}
                    </v-btn>
                    <v-btn rounded class="btn-primary-custom" @click="saveEgar(2)" :disabled="!form.valide">{{$t('send')}}</v-btn>
                </v-col>
            </v-row>
        </v-form>

        <!-- Modal Alerts. -->
        <base-modal v-model="modalAlert.show" modalAlign="align__flex--center" :title="modalAlert.title" modal-width="460px" :iconColor="modalAlert.iconColor" :iconName="modalAlert.iconName">
            <template v-slot:modal-close>
                <div @click="closeModalAlert()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.message}}
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn text :color="modalAlert.iconColor == 'warning' ? 'danger-button' : 'primary-button'"  @click="closeModalAlert()">
                        <span style="text-transform: capitalize">{{$t('ok')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Cancel Egar. -->
        <base-modal v-model="modalCancelEgar.show" modalAlign="align__flex--center" :title="modalCancelEgar.title" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalCancelEgar.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalCancelEgar.message}}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalCancelEgar.show = false">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="removeOrderEgar()">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {
    GetEgar,
    GetEgarPreFilled,
    GetEstablishment,
    GetProducerTypes,
    GetLerCode,
    GetOperationCode,
    GetActorsSenders,
    PostUpdadeEgar,
    CancelOrderEgars,
    PostPrintEgarForm
} from '@services/b2b/environmental-management/EgarService';
    import { required, maxLength, minLength } from '@src/utils/validations.js';
    import {
        EnvironmentalDocServicesGetSILiAmbContainerTypes
    } from "@services/b2b/environmental-management/DocumentationService";
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";
    export default {
        components: {BasePageHeader, BaseModal},
        data(){
            return{
                modalAlert: {
                    show: false,
                    title: '',
                    message: '',
                    iconName: '',
                    iconColor: '',
                    buttonRedirect: false,
                },
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.scheduling.entity-name'),
                        routerLinkName: 'environmentalManagementScheduling'
                    },
                    {
                        title: this.$t('environmental-management.scheduling.edit-request')
                    }
                ],
                modalCancelEgar: {
                    show: false,
                    title: '',
                    message: '',
                },
                lerCodes:[],
                operationCodes: [],
                entityName: this.$t('environmental-management.scheduling.entity-name'),
                formInputs: {
                    default: {
                        rules: [required]
                    },
                    nif: {
                        rules: [required, minLength(9),maxLength(9)]
                    },

                },
                form: {
                    valide: false,
                    producerType: 0,
                    producerEstablishment: {
                        nif: '',
                        name: '',
                        address: '',
                        postalCode: '',
                        locality: '',
                        apaCode: ''
                    },
                    recipientEstablishment: {
                        nif: "",
                        name: "",
                        address: "",
                        postalCode: "",
                        locality: "",
                        apaCode: ""
                    },
                    residuos: [{
                        designation: "",
                        lerCodeId: "",
                        operationCodeId: 0,
                        quantity: 0,
                        groupCode: "",
                        numberPgl: "",
                        containerTypeID: "",
                        containerQuantity: 0
                    }]
                },
                producersEstablishment: [],
                selectProducerEstablishment: [],
                producerType: [],
                recipientsEstablishment: [],
                selectRecipientEstablishment: null,
                actorsSenders: [],
                selectActorsSenders: null,
                actorsSenderTypes: [],
                selectActorsSendersType: null,
                selectLerCode: null,
                selectOperationCode: null,
                isRefreshProducers: false,
                isRefreshRecipient: false,
                containerTypesItems: [],
                createDate: null
            }
        },
        computed: {
            userAuth() {
                return  this.$store.getters['auth/getState'];
            },
        },
        watch: {
            selectProducerEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.producerEstablishment.apaCode= newValue.apaCode
                        this.form.producerEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.producerEstablishment.address= newValue.headquartersAddress
                        this.form.producerEstablishment.locality= newValue.headquartersLocality
                        this.form.producerEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.producerEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectRecipientEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.recipientEstablishment.apaCode= newValue.apaCode
                        this.form.recipientEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.recipientEstablishment.address= newValue.headquartersAddress
                        this.form.recipientEstablishment.locality= newValue.headquartersLocality
                        this.form.recipientEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.recipientEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectActorsSenders:{
                handler: function(newValue, oldValue) {
                    if(newValue.sendersType){
                        this.actorsSenderTypes = newValue.sendersType
                    }
                },
                immediate: false,
                deep: true
            },
        },
        methods:{
            cancelEgar(){
                this.$router.push({name: "environmentalManagementScheduling"})
            },
            removeOrderEgar(){
                this.modalCancelEgar.show = false;
                if(this.$route.params.id> 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return CancelOrderEgars(this.$route.params.id)
                        .then(response => {
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg1')
                            this.modalAlert.title = this.$t('environmental-management.scheduling.modal-alert.title1')
                            this.modalAlert.iconName = 'mdi-shield-check';
                            this.modalAlert.iconColor = 'success';
                            this.modalAlert.buttonRedirect = true
                            this.modalAlert.show = true;
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg2')
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            throw new Error('error to modalCancelEgar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            changeOperationCode(index){
                if(this.form.residuos[index].operationCodeId){
                    this.operationCodes.map(el =>
                    {
                        if(el.operationCodeID == this.form.residuos[index].operationCodeId){
                            this.form.residuos[index].groupCode = el.operationCode
                            this.form.residuos[index].operationCode = el.operationCode
                            this.form.residuos[index].numberPgl = el.averageWeight
                        }
                    })
                }
            },
            closeModalAlert(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                this.modalAlert.show = false;

                if(this.modalAlert.buttonRedirect){
                    this.$router.push({name: "environmentalManagementScheduling"})
                }
                this.$store.commit('loadings/setStateLoadingTemplate', false);

            },
            getEGAR(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetEgar(this.$route.params.id)
                    .then(response => {
                        if(response.data.result === ''){
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg8')
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.buttonRedirect = true
                            this.modalAlert.show = true;
                        }else{
                            this.selectActorsSenders = this.actorsSenders.filter( el => el.actorTypeID == response.data.result.actorType)[0];
                            this.actorsSenderTypes = this.selectActorsSenders.sendersType
                            this.selectActorsSendersType = this.actorsSenderTypes.filter( el => el.senderTypeID == response.data.result.senderType)[0];

                            this.producersEstablishment = [{
                                apaCode: response.data.result.producer.apaCode,
                                authorizeIssuance: true,
                                headquartersAddress: response.data.result.producer.address,
                                headquartersLocality: response.data.result.producer.locality,
                                headquartersPostalCode: response.data.result.producer.postalCode,
                                name: response.data.result.producer.name,
                                nif: response.data.result.producer.nif,
                            }]
                            this.selectProducerEstablishment = {
                                apaCode: response.data.result.producer.apaCode,
                                authorizeIssuance: true,
                                headquartersAddress: response.data.result.producer.address,
                                headquartersLocality: response.data.result.producer.locality,
                                headquartersPostalCode: response.data.result.producer.postalCode,
                                name: response.data.result.producer.name,
                                nif: response.data.result.producer.nif,
                            }

                            this.form.producerEstablishment.nif =  response.data.result.producer.nif
                            this.form.producerEstablishment.name =  response.data.result.producer.name
                            this.form.producerEstablishment.address =  response.data.result.producer.address
                            this.form.producerEstablishment.postalCode =  response.data.result.producer.postalCode
                            this.form.producerEstablishment.locality =  response.data.result.producer.locality
                            this.form.producerEstablishment.apaCode =  response.data.result.producer.apaCode

                            this.form.producerType = +response.data.result.producerType

                            this.form.recipientEstablishment = response.data.result.recipient

                            this.form.residuos = response.data.result.transportedResidue

                            this.form.residuos[0].lerCodeId = this.lerCodes.filter(el => el.lerCode == response.data.result.transportedResidue[0].residueLerCode)[0].lerCodeId;
                            this.form.residuos[0].designation = this.lerCodes.filter(el => el.lerCode == response.data.result.transportedResidue[0].residueLerCode)[0].description;

                            this.form.residuos[0].codigoLer = this.lerCodes.filter(el => el.lerCode == response.data.result.transportedResidue[0].residueLerCode)[0].lerCode;

                            this.form.residuos[0].operationCodeId = response.data.result.transportedResidue[0].operationCode
                            this.getOperationCodes(this.form.residuos[0].lerCodeId, 0 , this.form.residuos[0])

                            this.selectRecipientEstablishment = response.data.result.recipient

                            this.createDate = response.data.result.createDate
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        this.getRecipientEstablishmentNif()
                    })
            },
            getEgarPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetEgarPreFilled()
                    .then(response => {
                        if(response.data.result) {
                            this.form.producerEstablishment.nif = response.data.result.producerNif
                            this.producersEstablishment = response.data.result.producerEstablishments.map(el => {
                                return {
                                    apaCode: el.apaCode,
                                    authorizeIssuance: true,
                                    headquartersAddress: el.fullName,
                                    headquartersLocality: el.locality,
                                    headquartersPostalCode: el.postalCode,
                                    name: el.name,
                                    nif: response.data.result.producerNif,
                                }
                            })

                            this.recipientsEstablishment = response.data.result.recipientEstablishments.map(el => {
                                return {
                                    apaCode: el.apaCode,
                                    authorizeIssuance: true,
                                    headquartersAddress: el.fullName,
                                    headquartersLocality: el.locality,
                                    headquartersPostalCode: el.postalCode,
                                    name: el.name,
                                    nif: response.data.result.recipientNif,
                                }
                            })

                            this.selectRecipientEstablishment = this.recipientsEstablishment[0]
                            this.form.recipientEstablishment.nif = response.data.result.recipientNif
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            obterProducer(){
                this.isRefreshProducers = true;
                this.getProducersEstablishmentNif()
            },
            getProducersEstablishmentNif(){
                this.selectProducerEstablishment = [];
                this.form.producerEstablishment.name = ''
                this.form.producerEstablishment.address = ''
                this.form.producerEstablishment.postalCode = ''
                this.form.producerEstablishment.locality = ''
                this.form.producerEstablishment.apaCode = ''

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshProducers
                };
                if(this.form.producerEstablishment.nif){
                    if(this.form.producerEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.producerEstablishment.nif,
                        isRefresh: this.isRefreshProducers
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.producersEstablishment = response.data.result
                            }else{
                                this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg3')
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshProducers = false
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
                return
            },
            obterRecipient(){
                this.isRefreshRecipient = true;
                this.getRecipientEstablishmentNif()
            },
            getRecipientEstablishmentNif(){
                this.selectRecipientEstablishment = [];
                this.form.recipientEstablishment.name = ''
                this.form.recipientEstablishment.address = ''
                this.form.recipientEstablishment.postalCode = ''
                this.form.recipientEstablishment.locality = ''
                this.form.recipientEstablishment.apaCode = ''
                this.recipientsEstablishment = []
                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshRecipient
                };
                if(this.form.recipientEstablishment.nif){
                    if(this.form.recipientEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.recipientEstablishment.nif,
                        isRefresh: this.isRefreshRecipient
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.recipientsEstablishment = response.data.result
                                this.selectRecipientEstablishment = response.data.result[0]
                            }else{
                                this.form.recipientEstablishment.nif = ''
                                this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg4')
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                            this.form.recipientEstablishment.nif = ''
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg4')
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            this.form.recipientEstablishment.nif = ''
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshRecipient = false
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
                return
            },
            getTypeProducer(){
                if(this.producerType.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetProducerTypes()
                        .then(response => {
                            this.producerType = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetProducerTypes egar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getLerCodes(){
                if(this.lerCodes.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetLerCode()
                        .then(response => {
                            this.lerCodes = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetLerCode values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getOperationCodes(lerCode, index, residuo){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const lerCodes = _.cloneDeep(this.lerCodes)
                residuo.codigoLer = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].lerCode
                residuo.designation = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].description
                return GetOperationCode(lerCode)
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.operationCodes = response.data.result
                            this.form.residuos[0].operationCodeId = +this.operationCodes.filter(el => el.operationCode == this.form.residuos[0].operationCodeId)[0].operationCodeID;

                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetLerCode values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            getActorsSender(){
                if(this.actorsSenders.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetActorsSenders()
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.actorsSenders = response.data.result
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetActorsSenders values', error);
                        })
                        .finally(() => {

                            this.getEGAR();
                            //this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }

            },
            saveEgar(status){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                if(this.form.producerEstablishment.apaCode == this.form.recipientEstablishment.apaCode){

                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg5')
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;

                    return
                }

                let body = {
                    producerNif: this.form.producerEstablishment.nif,
                    actorTypeId: this.selectActorsSenders.actorTypeID,
                    producerTypeId: this.form.producerType,
                    senderTypeId: this.selectActorsSendersType.senderTypeID,
                    recipientNif: this.form.recipientEstablishment.nif,
                    statusId: status,
                    producerEstablishment: {
                        name: this.form.producerEstablishment.name,
                        address: this.form.producerEstablishment.address,
                        postalCode: this.form.producerEstablishment.postalCode,
                        locality: this.form.producerEstablishment.locality,
                        apaCode: this.form.producerEstablishment.apaCode
                    },
                    recipientEstablishment: {
                        name: this.form.recipientEstablishment.name,
                        address: this.form.recipientEstablishment.address,
                        postalCode: this.form.recipientEstablishment.postalCode,
                        locality: this.form.recipientEstablishment.locality,
                        apaCode: this.form.recipientEstablishment.apaCode
                    },
                    residues: this.form.residuos[0]
                }

                return PostUpdadeEgar(this.$route.params.id, body)
                .then(response => {
                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg9')
                    this.modalAlert.title = this.$t('environmental-management.scheduling.modal-alert.title3')
                    this.modalAlert.iconName = 'mdi-shield-check';
                    this.modalAlert.iconColor = 'success';
                    this.modalAlert.show = true;
                    this.modalAlert.buttonRedirect = true
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    this.form.recipientEstablishment.nif = ''
                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg10')
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    throw new Error('error to get GetActorsSenders values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            async getSILiAmbContainerTypes() {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                await EnvironmentalDocServicesGetSILiAmbContainerTypes()
                    .then(response => {
                        if (response.data.result) {
                            response.data.result.forEach(recipe => {
                                let newRecipe = {
                                    ...recipe,
                                    text: recipe.description,
                                    value: recipe.containerTypeId
                                }
                                this.containerTypesItems.push(newRecipe);
                            })
                        } else {
                            this.containerTypesItems = [];
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error EnvironmentalDocServicesGetSILiAmbContainerTypes', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
            },
            async printEgarForm() {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const filledResidues = this.form.residuos.filter(residue =>
                    residue.designation || residue.codigoLer || residue.quantity || residue.containerTypeID || residue.containerQuantity
                ).map(residue => {
                    const containerType = this.containerTypesItems.find(item => item.value === residue.containerTypeID);
                    return {
                        designation: residue.designation || "",
                        lerCode: residue.codigoLer || "",
                        quantity: residue.quantity === 0 ? "" : residue.quantity.toString(),
                        containerType: containerType ? containerType.text : null,
                        containerQuantity: residue.containerQuantity === 0 ? "" : residue.containerQuantity.toString()
                    };
                });

                const emptyRows = Array(filledResidues.length > 0 ? 0 : 16).fill({
                    designation: "",
                    lerCode: "",
                    quantity: "",
                    containerType: null,
                    containerQuantity: ""
                });

                let data = {
                    nif: this.form.producerEstablishment.nif,
                    name: this.form.producerEstablishment.name,
                    address: this.form.producerEstablishment.address,
                    postalCode: this.form.producerEstablishment.postalCode,
                    locality: this.form.producerEstablishment.locality,
                    createdDate: this.formatDate(this.createDate),
                    residue: [...filledResidues, ...emptyRows]
                };

                return PostPrintEgarForm(data)
                    .then(response => {
                        const blob = new Blob([response.data], {type: 'application/pdf'});
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        window.open(link);
                    })
                    .catch(error => {
                        console.error('Error downloading EGAR form:', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            },
        },

        mounted() {
            if(!this.userAuth.isAdminSILiAmb){
                this.getEgarPreFilled()
            }

            this.getSILiAmbContainerTypes()
            this.getTypeProducer()
            this.getLerCodes()
            this.getActorsSender()
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.btn-red{
    border-radius: 28px;
    background: $red;
}
</style>
